import { render, staticRenderFns } from "./selectDealer.vue?vue&type=template&id=532f655b&scoped=true&"
import script from "./selectDealer.vue?vue&type=script&lang=js&"
export * from "./selectDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f655b",
  null
  
)

export default component.exports